import { isExpectedError } from "~/lib/api.js";

import * as segment from "~/util/segment.js";
import * as sentry from "~/util/sentry.js";

import * as env from "~/admin/env.js";

if (import.meta.env?.PRODUCTION) {
	console.log("%c⚠️ STOP!!! ⚠️", "font-size: 3em; font-weight: 900");
	console.log(
		"%cThis is a feature for Phaze developers. If someone told you to copy or paste something here, it is a scam and will give them access to your computer.",
		"color: red; font-size: 2em; font-weight: 900",
	);
}

if (env.sentryDsn && env.sha && env.environment) {
	sentry.init({
		dsn: env.sentryDsn,
		release: env.sha,
		environment: env.environment,
		isExpectedError,
	});
}

if (env.segmentWriteKey) {
	segment.init({ writeKey: env.segmentWriteKey, properties: { environment: env.environment } });
}

import { effect } from "@preact/signals";
import { h, render } from "preact";

import { apiHost } from "~/lib/api.js";
import { identity } from "~/lib/identity.js";
import { bindSession, cookieSession, loggedIn } from "~/lib/session.js";

import { setTitleDecoration } from "~/util/title.js";

import Admin from "./page/Admin.js";

import { CSS_MODULE_SCRIPTS } from "~/util/css.js";

if (CSS_MODULE_SCRIPTS) import("~/index.css", { with: { type: "css" } });

// set the api host from the environment
apiHost.value = env.apiHost.includes("://") ? env.apiHost : `https://${env.apiHost}`;

// the admin panel owns its session in a cookie
bindSession(cookieSession());

effect(() => {
	if (!loggedIn.value) segment.reset();
	else if (identity.me) {
		segment.identify(identity.me.id, {
			email: identity.me.email,
			email_domain: identity.me.email.slice(identity.me.email.lastIndexOf("@") + 1),
			enterprise_id: identity.enterprise?.id,
			enterprise_name: identity.enterprise?.name,
		});
	}
});

// add "Phaze | " as a prefix to any title changes
setTitleDecoration(title => `Phaze | ${title}`);

// render the app UI
const app = /** @type {HTMLElement} */ (document.querySelector("#app"));
render(h(Admin, null), app);
